/*
 * Notification that the user has completed an assignment.
 */
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import {BaseToastNotification} from "@khan/component-toast";

// sync-start:assignment-completed-notification 209350914 https://github.com/Khan/webapp/blob/master/services/progress/shared/notifications.go
interface Props {
    // Whether this is the first time this assignment has been completed
    firstCompletion: boolean;
    // The name of the student list associated with this assignment, if any
    studentListName: string | null | undefined;
}
// sync-end:assignment-completed-notification

const AssignmentCompletedNotification = (props: Props): React.ReactNode => {
    const {firstCompletion, studentListName} = props;

    if (!firstCompletion) {
        // We only show this toast notification on first completion
        return null;
    }

    const content = studentListName ? (
        <Trans>
            You completed your assignment for <strong>{studentListName}</strong>
            .
        </Trans>
    ) : (
        t`You completed your assignment!`
    );

    return <BaseToastNotification>{content}</BaseToastNotification>;
};

export default AssignmentCompletedNotification;
